import publicSocket, { PublicSocket } from 'sockets/publicSocket'

export const usePublicSocket = (): PublicSocket => {
  return publicSocket
}
